
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clientapp/auth/forgot-password",
      function () {
        return require("private-next-pages/clientapp/auth/forgot-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clientapp/auth/forgot-password"])
      });
    }
  